import useContextForLocation from './use-context-for-location.js';
import useDecodeContextLocation from './use-decode-context-location.js';

const useIsContextLocationOpen = location => {
	const context = useContextForLocation(location);
	const decodedLocation = useDecodeContextLocation(context);
	return decodedLocation?.pathname === location;
};

export default useIsContextLocationOpen;
